import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ChevronRight } from "lucide-react";
import { api, absoluteUrl } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { TID } from "@/constants/testIds";
import { Input } from "@/components/ui/input";

const inr = (v) => `₹${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export default function Orders() {
  const { t } = useI18n();
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    const h = setTimeout(() => {
      api.get("/designs", { params: q ? { q } : {} }).then((r) => setItems(r.data || []));
    }, 150);
    return () => clearTimeout(h);
  }, [q]);

  return (
    <div className="space-y-5">
      <div>
        <div className="sq-label">{t("orders")}</div>
        <h1 className="text-3xl font-heading font-bold mt-1 text-secondary">{t("ordersTitle")}</h1>
      </div>

      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" size={18} />
        <Input
          data-testid={TID.ordersSearch}
          placeholder={t("search")}
          className="h-12 pl-10"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      {items.length === 0 && (
        <div className="sq-card p-10 text-center text-muted-foreground">{t("empty")}</div>
      )}

      <div className="space-y-3">
        {items.map((d) => (
          <button
            key={d.id}
            data-testid={TID.ordersItem}
            onClick={() => nav(`/results/${d.id}`)}
            className="w-full flex items-center gap-3 sq-card p-3 hover:border-primary/40 sq-tap text-left"
          >
            <img src={absoluteUrl(d.image_url)} alt="" className="w-16 h-16 rounded-lg object-cover bg-muted" />
            <div className="flex-1 min-w-0">
              <div className="font-semibold truncate">{d.design_name}</div>
              <div className="text-xs text-muted-foreground truncate">
                {d.garment_type} · {d.machine_brand} · {d.fabric_type}
              </div>
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground mt-1">
                {new Date(d.created_at).toLocaleDateString("en-IN")}
              </div>
            </div>
            <div className="text-right">
              <div className="font-heading font-bold text-lg">{inr(d.quote?.final_price)}</div>
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground">
                {d.quote?.delivery_date}
              </div>
            </div>
            <ChevronRight size={18} className="text-muted-foreground" />
          </button>
        ))}
      </div>
    </div>
  );
}
